module.exports = __webpack_public_path__ + "img/d92892b.png";